import React from "react";

export const trimOnBlur = (
  e: React.FocusEvent<any>,
  fieldName: string,
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setFieldValue: any,
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  handleBlur: any
): void => {
  setFieldValue(fieldName, e.target.value?.trim());
  handleBlur(e);
};
